import React, {FC, useMemo} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {useLocalize} from '../../../../srcCommon/internationalization/internationalizationContext';
import {TriggerWithConditions} from '../ruleTriggerHelpers';
import {
  RuleTriggerFromEventsDescription,
  ruleTriggersGroups,
  RuleTriggersTypesEnum,
} from '../ruleTriggerModel';
import {MultipleGroupsDropdownBox} from './dropdowns/multipleGroupsDropdownBox';
import {DropdownGroup} from './dropdowns/multipleGroupsDropdownHelpers';
import {useBundleService} from './hooks/useBundleService';
import {RuleTriggerGroupIcon} from './ruleTriggerGroupIcon';
import {RuleTriggerGroupTitle} from './ruleTriggerGroupTitle';

/*
 * Types.
 */

interface RuleTriggersPickerProps {
  selectedTriggers: ReadonlyArray<TriggerWithConditions>;

  onAddTrigger: HandlerOf<RuleTriggersTypesEnum>;
}

/*
 * Styles.
 */

/*
 * Component.
 */

export const RuleTriggersPicker: FC<RuleTriggersPickerProps> = (props) => {
  const {selectedTriggers, onAddTrigger, children} = props;
  const localize = useLocalize();

  const {unavailableTriggers} = useBundleService();

  const groups = useMemo(
    () =>
      ruleTriggersGroups.map((group) => {
        const dropdownGroup: DropdownGroup<RuleTriggersTypesEnum> = {
          title: <RuleTriggerGroupTitle id={group.id} />,
          icon: <RuleTriggerGroupIcon id={group.id} />,
          items: group.items,
          // Disable already selected triggers.
          disabledItems: [...unavailableTriggers, ...selectedTriggers.map(({trigger}) => trigger)],
          serializeItemForSearch: (item) => localize(RuleTriggerFromEventsDescription[item].title),
          renderItemLabel: (item) => localize(RuleTriggerFromEventsDescription[item].title),
          getItemKey: (item) => item,
        };

        return dropdownGroup;
      }),
    [selectedTriggers, unavailableTriggers],
  );

  return (
    <MultipleGroupsDropdownBox
      groups={groups}
      selectedItems={[]}
      canSelectMultipleItems={false}
      onChange={(selectedValue: ReadonlyArray<RuleTriggersTypesEnum>) => onAddTrigger(selectedValue[0])}
      renderButton={() => children}
      shouldMergeGroupsWhenSearch
      hasBackground
    />
  );
};
